import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';// eslint-disable-line no-unused-vars
import MenuItem from 'material-ui/MenuItem'; // eslint-disable-line no-unused-vars
import Checkbox from 'material-ui/Checkbox';

const propTypes = {
  giftcards: PropTypes.any,
  giftcard: PropTypes.object,
  onSave: PropTypes.func,
};

class ViewGiftCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    const { giftcard } = nextProps;
    this.setState({ giftcard });
  }
  navigateToEdit() {
    browserHistory.push(`/giftcards/edit/${this.state.giftcard.id}`);
  }
  handleCancel() {
    browserHistory.push('/giftcards?page=1');
  }
  render() {
    const styles = {
      scrollDivStyle: {
        width: '250px',
        display: 'inline-block',
        color: cyan900,
        fontSize: '12px',
        marginTop: '10px',
      },
      listStyle: {
        display: 'inline-block',
        verticalAlign: 'text-top',
        height: '70px',
        overflow: 'auto',
      },
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      datePickerStyle: {
        marginRight: '2%',
        width: '250px',
        float: 'left',
      },
    };
    const expire = (this.props.giftcard.expiration) ? new Date(this.props.giftcard.expiration).toLocaleDateString() : '';
    const purchase = (this.props.giftcard.datePurchased) ? new Date(this.props.giftcard.datePurchased).toLocaleDateString() : '';
    return (
      <div>
        <div className="float-right">
          <RaisedButton
            style={{ marginRight: '20px' }}
            label="Cancel"
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            style={{ marginRight: '20px' }}
            label="Edit"
            primary
            onClick={this.navigateToEdit}
          />
        </div>
        <br />
        <TextField
          floatingLabelText="Gift Card Code"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.code || ''}
          name="code"
          style={styles.inputStyle}
          disabled
        />
        <br />
        <TextField
          floatingLabelText="Purchaser Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.purchaserName || ''}
          name="purchaserName"
          style={styles.inputStyle}
          disabled
        />
        <TextField
          floatingLabelText="Purchaser Email"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.purchaserEmail || ''}
          name="purchaserEmail"
          style={styles.inputStyle}
          disabled
        />
        <TextField
          floatingLabelText="Recipient Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.recipientName || ''}
          name="recipientName"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Recipient Email"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.recipientEmail || ''}
          name="recipientEmail"
          style={styles.inputStyle}
          disabled
        />
        <br />
        <TextField
          floatingLabelText="Principal"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.principal || ''}
          name="recipientName"
          style={styles.inputStyle}
          disabled
        />
        <TextField
          floatingLabelText="Balance"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.balance || 0} 
          name="recipientEmail"
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Date Purchased"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={purchase}
          name="datePurchased"
          style={styles.inputStyle}
          disabled
        />
        <TextField
          floatingLabelText="Date Expires"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={expire}
          name="expiration"
          style={styles.inputStyle}
          disabled
        />
        <br />
        <br />
        <TextField
          floatingLabelText="Gift Card Message"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.props.giftcard.message || ''}
          name="message"
          multiLine
          underlineShow={false}
          rows={10}
          rowsMax={10}
          style={{ width: '60%' }}
          textareaStyle={{ border: '1px solid black' }}
          disabled
        />
        <br />
        <ul>
          <li>
            <Checkbox
              label="Disabled"
              checked={this.props.giftcard.disabled}
              name="disabled"
            />
          </li>
        </ul>
      </div>
    );
  }
}

ViewGiftCard.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ViewGiftCard.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    giftcards: state.giftCards,
    giftcard: state.giftCards.giftcard,
  };
}

export default connect(mapStateToProps)(ViewGiftCard);



// WEBPACK FOOTER //
// ./src/components/giftCards/ViewGiftCard.js